export type { UseModalOptions } from "./Hooks/useModal";
export { useModal } from "./Hooks/useModal";
export { Modal } from "./Modal";
